module.exports = __webpack_public_path__ + "static/media/mug-hot.939dcafa.svg";